import { jsx as _jsx } from "react/jsx-runtime";
import { faMars, faQuestion, faVenus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/**
 * Shows a gender icon based on the value in the gender prop.
 */ export const GenderIcon = (props)=>{
    const { gender, ...rest } = props;
    let iconName = faQuestion;
    switch(gender.toUpperCase()){
        case 'M':
        case 'MAN':
            iconName = faMars;
            break;
        case 'F':
        case 'KVINNA':
            iconName = faVenus;
            break;
    }
    return /*#__PURE__*/ _jsx(FontAwesomeIcon, {
        "data-testid": "GenderIcon",
        icon: iconName,
        ...rest
    });
};
